export const ROUTES = {
  HOME: "/",
  CONTACT_US: "/contact-us",
  CAUTION_NOTICE: "/caution-notice",
};
